import { Button } from '@aon/aon-tws-common-ui';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../appStore';
import { ISurveyTermEditModel } from '../../../models/ISurveyTermEditModel';
import { EditState } from '../../../models';
import { ISurveyTermItemEditModel } from '../../../models/ISurveyTermItemEditModel';
import { ActionCreators as CulturesActionCreators } from '../../../store/CulturesStore';
import { SurveyDefinitionsPreviewModal } from './SurveyDefinitionsPreviewModal';
import { setOpenedModalPopupName } from '../../../store/SurveyContentItemsSlice';

const PreviewButtonContainer = styled.div`
	text-align: right;
	width: 100%;
	position: relative;

	@media (max-width: 795px) {
		margin-top: 10px;
	}
`;

export interface ISurveyDefinitionsModuleProps {
	defaultCultureCode: string;
	supportedCultures: string[];
	surveyTerm: ISurveyTermEditModel;
	surveyTermItems: ISurveyTermItemEditModel[];
	surveyId: number;
	disabled: boolean;
}

export interface ISurveyDefinitionsModuleState {
	isOpen: boolean;
}

export interface IPreviewButtonProps {
	disabled: boolean;
	onClick: () => void;
}

export function PreviewButton(props: IPreviewButtonProps) {
	const { disabled, onClick } = props;

	return (
		<PreviewButtonContainer>
			<Button disabled={disabled} onClick={onClick} color='secondary'>
				Preview
			</Button>
		</PreviewButtonContainer>
	);
}

export function SurveyDefinitionsPreviewModule(props: ISurveyDefinitionsModuleProps) {
	const [isOpen, setIsOpen] = React.useState(false);
	const { defaultCultureCode, supportedCultures, surveyTerm, surveyTermItems, surveyId } = props;
	const validSurveyTermItems = surveyTermItems.filter((def) => def.term?.editState != EditState.Remove);

	const dispatch = useAppDispatch();
	const loadCultures = useAppSelector((state) => state.cultures).availableCultures.length === 0;

	useEffect(() => {
		if (loadCultures) {
			CulturesActionCreators.GetCultures()(dispatch);
		}
		if (isOpen) {
			dispatch(setOpenedModalPopupName('survey-term'));
		}
	}, [loadCultures, isOpen, dispatch]);

	function toggleModal() {
		setIsOpen(!isOpen);
	}

	return (
		<>
			<PreviewButton disabled={surveyTermItems.length < 1 || props.disabled} onClick={toggleModal} />
			{isOpen && (
				<SurveyDefinitionsPreviewModal
					surveyId={surveyId}
					isOpen={true}
					surveyTerm={surveyTerm}
					surveyTermItems={validSurveyTermItems}
					supportedCultures={supportedCultures}
					defaultCultureCode={defaultCultureCode}
					onClose={toggleModal}
				/>
			)}
		</>
	);
}
